export const mockSupportGroups = [
  {
    id: 'g1',
    name: "Spousal Loss Sanctuary",
    category: "Grief Support",
    description: "A gentle space for those navigating the journey of losing a life partner. We share stories and silent strength.",
    memberCount: 1240,
    creator: "Admin",
    isVerified: true,
    image: "https://images.unsplash.com/photo-1516589174184-c685ca33d2b0?q=80&w=2070&auto=format&fit=crop",
    whatsappLink: "https://chat.whatsapp.com/example1",
    members: [
      { id: 'u1', name: "Sarah Jenkins", avatar: "https://i.pravatar.cc/150?u=1", status: 'online', bio: "Healing day by day. Love to garden.", relation: "Spouse" },
      { id: 'u2', name: "David Miller", avatar: "https://i.pravatar.cc/150?u=2", status: 'offline', bio: "Retired architect. Finding peace in woodcarving.", relation: "Partner" },
      { id: 'u3', name: "Elena Rodriguez", avatar: "https://i.pravatar.cc/150?u=3", status: 'online', bio: "Writer and mother. Here to listen.", relation: "Spouse" },
      { id: 'u4', name: "Marcus Vane", avatar: "https://i.pravatar.cc/150?u=4", status: 'online', bio: "Veteran. Strength in numbers.", relation: "Widower" }
    ],
    posts: [
      {
        id: 'p1',
        author: "Sarah Jenkins",
        authorId: 'u1',
        content: "Today marks 2 years. The garden we planted together is finally in full bloom. It feels like a hug from the universe.",
        time: "2h ago",
        likes: 24,
        comments: 5,
        reactions: ['❤️', '🫂', '✨']
      }
    ]
  }
];